import { render, staticRenderFns } from "./appointment-five.vue?vue&type=template&id=47b6fd54&scoped=true"
import script from "./appointment-five.vue?vue&type=script&lang=js"
export * from "./appointment-five.vue?vue&type=script&lang=js"
import style0 from "./appointment-five.vue?vue&type=style&index=0&id=47b6fd54&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b6fd54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47b6fd54')) {
      api.createRecord('47b6fd54', component.options)
    } else {
      api.reload('47b6fd54', component.options)
    }
    module.hot.accept("./appointment-five.vue?vue&type=template&id=47b6fd54&scoped=true", function () {
      api.rerender('47b6fd54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/softBusinessLogistics/appointment-five.vue"
export default component.exports